// Backend business error code -> message (English)
// code is the key, val is the message; {0}/{1} are positional placeholders filled by t(key, args)
export default {
  error_code: {
    // Appointment
    '1001001': 'Status mismatch',
    '1001002': 'Modifying the appointment is not allowed',
    '1001003': 'Appointment not found',
    '1001004': 'Check-in unavailable',
    '1001005': 'Appointment already exists',
    '1001006': 'Insufficient slots',
    '1001007': 'Booking is not allowed',
    '1001008': 'Rollback is not allowed',
    '1001009': 'Patient not found',
    '1001010': 'Incorrect API usage',
    '1001011': 'Appointment not found: {0}',
    '1001012': 'Re-dispensing is not allowed for non-today appointments',
    // Coupon
    '1002001': 'Unsupported coupon type: {0}',
    '1002002': 'Coupon name already exists',
    '1002003': 'Only user coupons can be issued',
    '1002004': 'Cannot be used',
    '1002005': 'Unsupported type',
    '1002006': 'Expired',
    '1002007': 'Cannot be modified',
    '1002008': 'Cannot be deleted',
    '1002009': 'There are unused coupons',
    // Medicine
    '1003001': 'Saving is not allowed',
    '1003002': 'Duplicate drug sign-off',
    '1003003': 'Barcode not found',
    '1003004': 'Drug has expired',
    '1003005': 'Insufficient stock',
    '1003006': 'Drug has been changed',
    '1003007': 'No data',
    '1003008': 'Specification not found',
    '1003009': 'Amount is too large, please verify or split the order',
    '1003010': 'Organization dictionary mapping is not ready, waiting for InitOrgDict',
    '1003011': 'Duplicate code',
    '1003012': 'Code cannot be duplicated',
    '1003013': 'Barcode already exists',
    '1003014': 'QR code already exists',
    '1003015': 'Drug has been taken off the shelf',
    '1003016': 'Drug has expired',
    '1003017': 'Drug not found or disabled',
    '1003018': 'Drug has been changed, please re-add',
    // Payment
    '1004001': 'Payment error',
    '1004002': 'Failed to place the order',
    '1004003': 'No available payment order',
    '1004004': 'Refund order already exists',
    '1004005': 'Refund failed',
    '1004006': 'Refund is not supported',
    '1004007': 'Status mismatch',
    '1004008': 'Incorrect payment amount',
    '1004009': 'Incorrect charge amount',
    '1004010': 'Payment method unavailable',
    '1004011': 'Insufficient balance',
    '1004012': 'Order has been changed',
    '1004013': 'There are unpaid items',
    '1004014': 'Related appointment not found or invalid',
    '1004015': 'Treatment is not completed, please refresh and retry later',
    '1004016': 'Product information not found',
    '1004017': 'Product has been changed',
    '1004018': 'This charge item already exists',
    '1004019': 'Charge item {0} is misconfigured',
    '1004020': 'SourceId cannot be empty',
    '1004021': 'Charge item {0} has no concentrated/decoction charging rule',
    '1004022': '{0}: incorrect document',
    '1004023': '{0}: incorrect document, item not found',
    '1004024': 'Document has been changed, please initiate payment again',
    '1004025': 'Document has been changed, please verify the document status',
    '1004026': 'Payment in progress, refund is not allowed',
    '1004027': 'Refund already exists, please retry later',
    '1004028': '{0}: product has been taken off the shelf',
    '1004029': '{0}: package unavailable',
    '1004030': 'Item {0} is not charged',
    // Product
    '1005001': 'Barcode already exists',
    '1005002': 'Insufficient stock',
    '1005003': 'Not enabled',
    '1005006': 'System is busy, please retry later',
    '1005007': 'Product has been taken off the shelf',
    '1005008': 'Product has expired',
    // Slots
    '1006001': 'No slots available',
    // Staff
    '1007001': 'Staff not found',
    '1007002': 'Staff is disabled',
    '1007003': 'Staff already exists',
    // Stocktake
    '1008001': 'Stocktake order not found',
    '1008002': 'Drug specification not found: {0}',
    '1008003': 'Cannot delete details in the current status',
    '1008004': 'Stocktake details cannot be empty',
    // Stock adjustment
    '1009001': 'Cannot edit in the current status',
    '1009002': 'Difference cannot be 0',
    '1009003': 'Drug specification not found',
    '1009004': '{0}: insufficient stock, current stock: {1}',
    '1009005': 'Deletion is not allowed',
    '1009006': 'Adjustment details cannot be empty',
    // Package
    '1010001': 'Already used, deletion is not allowed',
    '1010002': 'Package items cannot be empty',
    '1010003': 'Duplicate item: {0}',
    // Others
    '1011001': 'Editing is not allowed',
    '1012001': 'Duplicate name',
    // Clinic
    '2001001': 'Code already exists',
    '2001002': 'Code unavailable',
    '2001003': 'Clinic not found',
    '2001004': 'Clinic unavailable',
    '2001005': 'Incorrect parameter',
    '2001006': 'Prefix cannot be duplicated',
    '2001007': 'Generation days cannot be less than 1 day',
    '2001008': 'Interval cannot be less than 10 minutes',
    // Organization
    '2002001': 'Code already exists',
    '2002002': 'Admin account and password cannot be empty when creating an organization',
    '2002003': 'Organization not found',
    '2002004': 'No operation permission',
    '2002005': 'Phone number is empty',
    '2002006': 'Incorrect verification code',
    // Key
    '2003001': 'Key unavailable',
    '2003002': 'Key has expired',
    // Staff
    '2004001': 'Staff not found',
    '2004002': 'Staff unavailable',
    '2004003': 'Staff already exists',
    '2004004': 'Data exists, deletion is not allowed',
    '2004005': 'Appointment exists, deletion is not allowed',
    // Role
    '2005001': 'Role not found',
    '2005006': 'Please contact the administrator',
    // User
    '2006001': 'User not found',
    '2006002': 'User unavailable',
    '2006003': 'Organization user limit has been reached',
    '2006004': 'Enabling staff is not allowed',
    '2006007': 'Organization code cannot be empty',
    '2006008': 'Account already exists',
    // Tag
    '2007001': 'Tag already exists',
    // Patient
    '2008001': 'Incorrect account or password',
    '2008002': 'Incorrect password',
    '2008003': 'ID document already exists',
    '2008004': 'Name and phone already exist',
    '2008005': 'Account already exists',
    '2008006': 'Staff already exists',
    '2008007': 'User not found',
    '2008008': 'Phone number does not match',
    '2008009': 'Original password does not match',
    // Login
    '2009001': 'Insufficient balance',
    '2009002': 'Incorrect domain',
    '2009003': 'Clinic unavailable',
    '2009004': 'Clinic not found',
    '2009005': 'Organization is disabled, login is not allowed',
    '2009006': 'User not found',
    '2009007': 'User unavailable',
    '2009008': 'Login is not allowed! Initial password is not set, please contact the administrator',
    '2009009': 'Incorrect password, please re-enter',
    '2009010': 'Not a member of this clinic, login is not allowed',
    '2009011': 'Login is not allowed! Password is not set yet, please contact the administrator',
    '2009012': 'Insufficient balance',
    // eHealth
    '2010001': 'Appointment not found',
    '2010002': 'Neither the doctor nor the patient has set an eHealth ID',
    '2010003': 'Doctor has not set an eHealth ID',
    '2010004': 'Patient has not set an eHealth ID',
    '2010005': 'Incorrect eHealth ID, please verify',
    // Referral code
    '2011001': 'Referral code already exists',
    '2011002': 'Referral code has been used by a patient and cannot be deleted',
    // Treatment
    '3001001': 'Modification is not allowed',
    '3001002': 'Drug {0} has no selling price',
    '3001003': 'Re-dispensing is not allowed',
    '3001004': 'Status has been changed',
    '3001005': 'Re-dispensing is not allowed',
    '3001006': 'Lab order not found',
    '3001007': 'Item name cannot be empty',
    '3001008': '{0}: item not found',
    '3001009': '{0}: item is disabled',
    '3001010': '{0}: incorrect prescription item',
    '3001011': 'Inconsistent herb count',
    '3001012': 'Exceeded the re-dispensing time limit',
    '3001013': 'Exceeded the re-dispensing dosage limit',
    '3001014': 'Please verify whether the document has been withdrawn for modification',
    '3001015': 'Dispensing order has been dispensed, please do not repeat',
    '3001016': 'Dispensing order item not found',
    '3001017': 'Dispensing order item has been dispensed, please do not repeat',
    // Drug specification
    '4001001': 'Specification exists, deletion is not allowed',
    // Verification code
    '5001001': 'Maximum quantity reached',
    '5001002': 'Please retry later',
    '5001003': 'Template is not enabled',
    // Common
    '9901001': 'Access denied',
    '9901002': 'Service error',
    '9901003': 'Incorrect parameter',
    '9901004': 'Abnormal data',
    '9901005': 'Processing data',
    '9901006': 'Failed to read the configuration',
    '9901007': 'Incorrect operation',
    '9901008': 'Editing is not allowed',
    '9901009': 'Deletion is not allowed',
    '9901010': 'Duplicate data',
    '9901011': 'Status has been changed',
    '9901012': 'No permission to query',
    '9901013': 'Item not found',
    '9902001': 'Incorrect login information, please log in again',
    '9902002': 'RedisConfig is empty',
    '9902003': 'Incorrect file',
  },
}
